import React from 'react';
import "../media/redirectToHomePage.css";

const RedirectToHomePage = () => {
  return (
    <div className='RHMainDiv'>
        <span className='RHText'>Finished your test. Click Exit to view result page.</span>
    </div>
  )
};

export default RedirectToHomePage;
